export default {
  trafficPlanTemplateId: 'Traffic plan template ID',
  courierPlanTemplateId: 'Courier plan template ID'
}
